import React, { useEffect, useMemo } from 'react'
import { useInstData, useEventHandler } from '../../public/hooks'
import { getMergedValues, changeItemsValue, getFormValue } from '../../public/utility'
import TreeSelect from '../../business/TreeSelect'

export default props => {
    const { setState, me, me: {
        state: {
            fieldset, refreshing = true, id
        }
    } } = useInstData(props, useMemo(() => ({
        state: {
            fieldset: [
                { _label: '装载中，请稍等...' }
            ],
            id: props.id,
        }
    })))

    const { onClose, onConfirm, flowAct, showBody: Body } = props

    const loadComponent = ({ /* name,  */type, refresh, ...field }) => {
        field && (field.minWidth = '100%')
        refresh && (field.onChange = tryRefresh)
        type == '_depselect' && (field = loadDepSelect(field))
        if (type == '_border') {
            var comps = [{ _label: field.name, minWidth: '100%' }]
            field.items && field.items.forEach(item => comps.push(...loadComponent(item)))
            return comps
        }
        return [field]
    }

    const loadDepSelect = (field) => {
        const { optionsParas } = me.state
        var options = []
        if (optionsParas && optionsParas.obj部门)
            options = optionsParas.obj部门[optionsParas.treeName].map(o => ({ text: optionsParas.obj部门[`${optionsParas.treeName}[${o}].fullName`], value: o }))
        return {
            _select: field._depselect, name: field.name + '_fullName', options, required: field.required, minWidth: '95%',
            onChange: (v) => { 
                changeItemsValue(me, '', [field.name + '_id', field.name, field.name + '_fullName'], [v, optionsParas.obj部门[`${optionsParas.treeName}[${v}].${optionsParas.treeField}`], optionsParas.obj部门[`${optionsParas.treeName}[${v}].fullName`]])
            }
        }
    } 

    // const handleShowDepSelectDiv = useEventHandler((title, onConfirm, onDelete) => {
    //     const { initValues, changedValues, optionsParas } = me.state
    //     const values = { ...initValues, ...changedValues, ...optionsParas }

    //     Tyan.pubForm.showDialog(title, props => <TreeSelect {...props} initValues={{ ...values.obj部门, treeName: values.treeName, treeField: values.treeField }} onConfirm={onConfirm} onDelete={onDelete} />)
    // })

    const handleLoadForm = () => {
        const stamp = me.refreshStamp = Date.now()
        Tyan.doPostEvent('GetFlowRecordAct', {
            // showFetchSpinner: false,
            data: { operateId: flowAct.operateId, id },
            onEnd: ({ errorMessage, components }) => {
                if (me.refreshStamp != stamp || me.unmounted) return
                if (errorMessage) {
                    Ext.toast(`读取流程配置数据失败: ${errorMessage}`)
                    console.error('读取流程配置数据失败:', errorMessage)
                    onClose()
                    return
                }
                var fieldset = []
                components && components.forEach(comp => fieldset.push(...loadComponent(comp)))
                // const fieldset = components && components.map(comp => {
                // 	return loadComponent(comp)
                // })
                setState({ fieldset })
                handleRefresh()
            }
        })
    }

    const handleRefresh = (values = {}) => {
        const { id } = me.state
        setState({ refreshing: true })
        const stamp = me.refreshStamp = Date.now()
        Tyan.doPostEvent('GetFlowRecordActData', {
            data: { operateId: flowAct.operateId, id, changedValues: values },
            onEnd: ({ errorMessage, initValues, optionsParas }) => {
                if (me.refreshStamp != stamp || me.unmounted) return
                if (errorMessage) {
                    Ext.toast(`读取流程数据失败: ${errorMessage}`)
                    return
                }
                setState({ initValues, optionsParas, refreshing: false })
            }
        })
    }

    const _haveRequired = (o, values) => {
        if (o._border)
            return o.items && o.items.filter(item => _haveRequired(item, values)).length > 0
        else
            return o.required && ((!o._files && (Object.keys(values).indexOf(o.name) == -1 || values[o.name] == null)) ||
                (o._files && (!getFormValue(me, '', o.name) || getFormValue(me, '', o.name).length == 0)))
    }

    const haveRequired = () => {
        const { initValues, changedValues } = me.state
        const values = { ...initValues, ...changedValues }
        return fieldset.filter(o => _haveRequired(o, values)).length > 0
    }

    const tryRefresh = () => {
        const values = getMergedValues(me, '')
        handleRefresh(values)
    }

    useEffect(() => {
        handleLoadForm()
    }, [])

    const handleCommit = button => {
        setState({ refreshing: true })
        const values = getMergedValues(me, '')
        !(Tyan.checkForm.promptLimited(me)) && onConfirm({
            button, values, callback: () => {
                setState({ refreshing: false })
            }
        })
    }

    const fieldsets = useMemo(() => [{
        title: '', name: '', _fieldset: fieldset/* , disabled: refreshing */
    }], [fieldset/* , refreshing */])

    //console.log('me:', me)
    return <Body data={me} isDialog={true} maxWidth="990"
        controls={
            [
                { _button: '提交', handler: handleCommit, disabled: haveRequired() || refreshing },
                { _button: '取消', handler: onClose },
            ]}

        fieldsets={fieldsets}
    />
}
